__turbopack_context__.v({
  "className": "andika_ac117e4b-module__Kw4ssW__className",
});
